import CryptoJS from 'crypto-js';

export const passwordEncrypt = 'f4k9f5w7f8g4er26';
export const iv = '0000000000000000';

/**
 * 加密密码
 * @param data 需要加密的数据
 * @returns 加密后的字符串
 */
export function encrypt(data: string): string {
  return CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(data),
    CryptoJS.enc.Utf8.parse(passwordEncrypt),
    {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  ).toString();
}

